import { FilterDefinitionDTO } from "../DTO/filterDefinitionDTO";
import { BasicRequest } from "./basicRequest";

export class UpdateFilterDefinitionRequest extends BasicRequest{
   
    public filterDefinition! : FilterDefinitionDTO;
    
    constructor(){
        super()
    }
}